import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { User } from '../../_models/user';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-zoho-commerce-user',
  templateUrl: './zoho-commerce-user.component.html',
  styleUrls: ['./zoho-commerce-user.component.scss'],
})
export class ZohoCommerceUserComponent implements OnInit {

  state: any;
  clientId: any;
  instructions: string = 'N';
  connectionName: any;
  clientSecret: any;
  storeOrganizationId: any;
  clientIdError: string;
  connectionNameError: string;
  clientSecretError: string;
  storeOrganizationIdError: string;

  constructor(public user: User) {
  }

  submitZoho() {
    this.clientIdError = "";
    this.connectionNameError = "";
    this.clientSecretError = "";

    if (!this.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (!this.connectionName) {
      this.connectionNameError = 'Please enter connectionName';
    }
    if (!this.clientSecret) {
      this.clientSecretError = 'Please enter clientSecret';
    }

    if (this.clientIdError != "" || this.connectionNameError != "" || this.clientSecretError != "") {
      return false;
    }
    var stateVar = this.clientId + "|" + this.connectionName + "|" + this.storeOrganizationId + "|" + this.user.accountOwnerId + "|" + this.clientSecret;
    console.log(stateVar);
    this.state = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(stateVar), 'secret key 123').toString());
    //this.state = CryptoJS.AES.encrypt(stateVar,"shiftppiction").toString();
    //alert("state:" + this.state);
    console.log("userState::" + this.state);

    window.location.href = "https://accounts.zoho.in/oauth/v2/auth?scope=ZohoCommerce.items.READ,ZohoCommerce.salesorders.CREATE,ZohoCommerce.salesorders.READ,ZohoCommerce.shipmentorders.CREATE,Desk.tickets.ALL,Desk.basic.READ&state=" + this.state + "&client_id=" + this.clientId + " &response_type=code&redirect_uri=https://app.shift.in/access/zohoAuth&access_type=offline&prompt=consent";
    // stateVar;
    this.state;
  }
  ngOnInit() {
  }
  showInstructions() {
    this.instructions = 'Y';
  }
}
